// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"6a3bc827","263":"dc681b3d","319":"d5122281","725":"ba6b9b26","836":"bc6f86b3","871":"0e82d6b2"}[chunkId] + ".chunk.css";
};